/**
 * JWT utility functions
 */

/**
 * Decode base64url string (JWT uses base64url, not standard base64)
 * Base64url uses - and _ instead of + and /, and omits padding
 * 
 * @param str - base64url encoded string
 * @returns decoded string
 * @throws Error if the string is invalid
 */
export const base64UrlDecode = (str: string): string => {
  let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const pad = base64.length % 4;
  if (pad) {
    if (pad === 1) {
      throw new Error('Invalid base64url string');
    }
    base64 += '='.repeat(4 - pad);
  }
  return atob(base64);
};

/**
 * Parse JWT token and return the payload
 * 
 * @param token - JWT token string
 * @returns Decoded JWT payload or null if invalid
 */
export const parseJwtPayload = (token: string): any | null => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }
    return JSON.parse(base64UrlDecode(parts[1]));
  } catch (error) {
    console.error('[jwtUtils] Error parsing JWT token:', error);
    return null;
  }
};

